import { Button, Col, Form, Row, Table } from "antd";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import COLORS from "common/Colors";
import { uniqBy } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getAllDepartmentList,
  getLocations,
  getUserList,
} from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
const ShiftViewWrap = styled.div`
  .header-view {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .change-view {
    border: none;
    color: #2d53da;
    font-size: 16px;
    font-weight: 400;
  }
  .change-view:hover {
    background-color: #e3e8fc !important;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const ShiftView = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const departmentList = useSelector(getAllDepartmentList);
  const locationList = useSelector(getLocations);
  const userList = useSelector(getUserList);
  const containerRef = useRef(null);
  const [filterShiftList, setFilterShiftList] = useState([]);
  const [shiftList, setShiftList] = useState([]);

  const employmentTypes = [
    "Casual",
    "Contract",
    "Full time",
    "Paid Internship",
    "Part time",
    "Training",
    "Unpaid Internship",
    "Probation",
  ];

  const handleFormChange = () => {
    const values = form.getFieldsValue();

    // If both filters are empty, show the full list
    if (
      (!values?.department || values.department.length === 0) &&
      (!values?.location || values.location.length === 0) &&
      (!values?.people || values.people.length === 0) &&
      (!values?.type || values.type.length === 0) &&
      (!values?.shift || values.shift.length === 0)
    ) {
      setFilterShiftList(userList);
      return;
    }

    const shiftFilter = userList.filter((user) => {
      const departmentMatch =
        !values.department?.length ||
        values?.department?.includes(user?.basedepartmentid);

      const locationMatch =
        !values.location?.length ||
        values?.location?.includes(user?.baselocationid);
      const peopleMatch =
        !values.people?.length || values?.people?.includes(user?.userid);
      const typeMatch =
        !values.type?.length || values?.type?.includes(user?.employementtype);
      return departmentMatch && locationMatch && peopleMatch && typeMatch;
    });

    setFilterShiftList(shiftFilter);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
    },
    {
      title: "Job Title",
      dataIndex: "jobtitle",
      key: "jobtitle",
    },
    {
      title: "Employment type",
      dataIndex: "employementtype",
      key: "employementtype",
    },
    {
      title: "Base Location",
      dataIndex: "baselocationid",
      key: "baselocationid",
      render: (text, record) => {
        return (
          <span>
            {
              locationList?.find((val) => val?.location_id === text)
                ?.location_name
            }
          </span>
        );
      },
    },
    {
      title: "Assigned Shift",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => {
        return <span>{text || "-"}</span>;
      },
    },
    {
      title: "",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, record) => (
        <>
          <Button type="link" corlor="red" className="text-danger" />
          <Button type="link" corlor="red" />
          <Button
            type="link"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    handleFormChange();
  }, [shiftList]);

  return (
    <ShiftViewWrap>
      <div className="header-view">
        <h5 className="">Shift</h5>
        <div className="header-buttons">
          <Button
            className="change-view"
            onClick={() => history.push("peopleview")}
          >
            People View
          </Button>
          <ButtonOutlined>Export CSV File</ButtonOutlined>
          <ButtonFilled type="primary" onClick={() => history.push("addshift")}>
            + Add Shift
          </ButtonFilled>
        </div>
      </div>

      <Form
        form={form}
        layout="vertical"
        className="mt-2"
        onValuesChange={handleFormChange}
      >
        <Row gutter={12} className="g-3 mb-2">
          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="people"
              label="Search People"
              options={uniqBy(
                userList.map((item) => {
                  return {
                    label: item?.fullname,
                    value: item?.userid,
                  };
                }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="type"
              label="Type"
              options={uniqBy(
                employmentTypes.map((item) => {
                  return {
                    label: item,
                    value: item,
                  };
                }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="shift"
              label="Shift"
              options={uniqBy(
                [].map((item) => {
                  return {
                    label: item?.location_name,
                    value: item?.location_id,
                  };
                }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="department"
              label="Department"
              options={uniqBy(
                departmentList?.map((item) => {
                  return {
                    label: item?.department_name,
                    value: item?.department_id,
                  };
                }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>

          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="location"
              label="Location"
              options={uniqBy(
                locationList
                  ?.filter((item) => item?.login_from_anywhere !== 1)
                  .map((item) => {
                    return {
                      label: item?.location_name,
                      value: item?.location_id,
                    };
                  }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>
        </Row>
      </Form>
      <div className="d-flex justify-content-between align-items-center">
        <p>Total People: {filterShiftList?.length}</p>
        <div className="d-flex align-items-center gap-2">
          <Button type="link">Change Shift</Button>
          <Button type="link">Assign Shift</Button>
        </div>
      </div>

      <StyledTable
        dataSource={filterShiftList}
        columns={columns}
        rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
        rowKey="userid"
        pagination={false}
        //   onRow={(record) => {
        //     return {
        //       onClick: () => {
        //         setIsViewInfo(true);
        //         setSelectedShift(record);
        //       },
        //     };
        //   }}
      />
    </ShiftViewWrap>
  );
};

export default ShiftView;
